// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"d74e0785","256":"b2fab208","551":"56583b92","559":"2dd41724","617":"3e23c185","842":"75b4adf1"}[chunkId] + ".chunk.js";
};